import React from "react";
import { Image, Spin } from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { LoadingOutlined } from "@ant-design/icons";
// import loader from "../../assets/svg/loadingHearts.gif";
import loader from "../../assets/svg/runningheart.gif";
// import loader from "../../assets/svg/love.png";

const Pageloading = styled.div`
	${tw`min-h-screen min-w-full flex items-center justify-center fixed inset-0`}
	background: #ff5a6212;
	z-index: 100000;
`;

const LoaderWrapper = styled.div`
	${tw`flex items-center justify-center absolute inset-0`}
	height: 100%;
	width: 100%;
	background: #ff5a6212;
	z-index: 10000;
`;
export const FullPageLoad = (props) => {
	return (
		<Pageloading>
			<Spin
				indicator={
					<Image
						preview={false}
						src={loader}
						alt=""
						tw="w-36 h-36 bg-white text-appPink shadow-2xl rounded-full p-5"
					/>
				}
				tip={props.tip}
				delay={props.delay}
				size="large"
			/>
		</Pageloading>
	);
};

export const PageLoading = (props) => {
	return (
		<LoaderWrapper>
			<Spin
				indicator={
					<Image
						preview={false}
						src={loader}
						alt=""
						tw="w-24 h-24 bg-white text-appPink shadow-2xl rounded-full p-4"
					/>
				}
				tip={props.tip}
				delay={props.delay}
				size="large"
			/>
		</LoaderWrapper>
	);
};

export const Loading = (props) => {
	const antIcon = (
		<LoadingOutlined
			style={{ fontSize: props.resize ? props.resize : 32 }}
			spin
			className={props.className}
			tw="text-gray-200"
		/>
	);
	return (
		<Spin
			indicator={props.icon ? props.icon : antIcon}
			tip={props.tip}
			size={props.size}
			delay={props.delay}
			spinning={props.loading}> 
			{props.children}
		</Spin>
	);
};
